import React from 'react';
import MagicForm from '../../../../Components/Form/MagicForm';
import { ItemScheme } from '../../../../Components/Form/MagicFormItem';

interface Props {
	formScheme: ItemScheme[];
	onSubmit: (values: any) => void;
	defaultValues?: object;
}

const MedicalRequestCreateForm: React.FC<Props> = ({
	formScheme,
	defaultValues,
	onSubmit,
}) => {
	const handleSubmit = (values: any) => {
		onSubmit(values);
	};

	return (
		<MagicForm
			formScheme={formScheme}
			defaultValues={defaultValues}
			onSubmit={handleSubmit}
			submitText='base.create'
		/>
	);
};

export default MedicalRequestCreateForm;
